import { auth, db, FieldValue } from 'helpers/firebase';
import { USER_STATUS } from 'constants/user';
const serverTimestamp = FieldValue.serverTimestamp;

//CRUD

export const createUser = (uid, params) => {
  if (!uid) {
    return Promise.reject('uid is requried');
  }

  const userRef = db.doc(`/users/${uid}`)
  return userRef.set({
    ...params,
    created_at: serverTimestamp(),
    modified_at: serverTimestamp()
  });
}

export const getUser = (uid) => {
  if (!uid) {
    return Promise.reject('uid is required');
  }
  const userRef = db.doc(`/users/${uid}`)
  return userRef.get()
}

export const upsertUser = (uid, params) => {
  if (!uid) {
    return Promise.reject('uid is requried');
  }

  const userRef = db.doc(`/users/${uid}`);
  return userRef.get()
    .then(user => {
      if (user.exists) {
        return userRef.update({
          ...params,
          modified_at: serverTimestamp()
        })
      } else {
        return userRef.set({
          ...params,
          created_at: serverTimestamp(),
          modified_at: serverTimestamp(),
          status: USER_STATUS.WAITING_FOR_REVIEW,
        })
      }
    });
}

export const deleteUser = (uid) => {
  if (!uid) {
    return Promise.reject("uid is required");
  }
  const userRef = db.doc(`/users/${uid}`)
  return userRef.update({ status: USER_STATUS.REMOVED });
}

//Role
export const getRole = user_id => {
  if (!user_id) {
    return Promise.reject(new Error("user_id is required"));
  }
  const ref = db.doc(`/roles/${user_id}`);
  return ref.get().then(snap => snap.data());
};


// collection
export const getUsersRef = () => {
  const ref = db.collection("/users").orderBy("created_at", "desc");
  return ref;
}

export const getAllUsersCount = () => {
  const ref = db.collection('/users');
  return ref.get()
    .then(colSnap => colSnap.count)
}

